
const digest = 'fe31e70f32942f7f86b2cc48d948151a5f98f6987d2a1ed458312b174bf28b20';
const classes = {"container":"_container_14ot2_1","alignCenter":"_alignCenter_14ot2_7","item":"_item_14ot2_11"};
const css = `._container_14ot2_1 {
  display: flex;
  flex-direction: row;
  gap: 12px;
}

._alignCenter_14ot2_7 {
  align-items: center;
}

._item_14ot2_11 {
  flex: 1;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  